'use client';

import React, { forwardRef } from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import styled from '@emotion/styled';
import { color } from '@/theme/tokens';

const StyledIconButton = styled(IconButton)`
    &:hover {
        background-color: ${color.white[10]};
    }
    &:active {
        background-color: ${color.white[20]};
    }
    &.Mui-focusVisible {
        outline: 2px solid ${color.white[0]};
        outline-offset: 2px;
    }
`;

const IconButtonWhite = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
    return <StyledIconButton disableRipple ref={ref} {...props} />;
});

IconButtonWhite.displayName = 'IconButtonWhite';

export default IconButtonWhite;
